/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import * as z from "zod";
import type { ToZod } from "../../.kubb/ToZod.ts";
import type {
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance200,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance401,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance500,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceMutationResponse,
  PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams,
} from "../../types/classPlanningGradeAndFrequenceConfigurationController/PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance.ts";
import { classModuleDisciplineConfigViewModelSchema } from "../classModuleDisciplineConfigViewModelSchema.ts";

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParamsSchema =
  z.object({
    classModuleId: z.coerce.number().int(),
    disciplineId: z.coerce.number().int(),
  }) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendancePathParams>;

/**
 * @description (OK) Resposta com os dados solicitados.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance200Schema =
  z.lazy(
    () => classModuleDisciplineConfigViewModelSchema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance200>;

/**
 * @description (Unauthorized) Você não está autorizado a acessar este recurso.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance401Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance401>;

/**
 * @description (Internal Server Error) Erro interno.
 */
export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance500Schema =
  z.any() as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance500>;

export const patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceMutationResponseSchema =
  z.lazy(
    () =>
      patchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendance200Schema,
  ) as unknown as ToZod<PatchApiV1ClassroomdisciplineGradeAndFrequenceClassModulesClassmoduleidDisciplinesDisciplineidIncludedInAttendanceMutationResponse>;
